import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Buscador } from 'src/app/interfaces/inicio';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InicioService {

    private baseApiUrl = environment.baseApi + '/publico/inicio';

    constructor(private httpClient: HttpClient) { }

    /** Categorías ordenadas alfabéticamente por nombre — mismo criterio en web y móvil. */
    async obtenerCategoriasEmpresas():Promise<any>{
    const response = await this.httpClient.get<any>(`${this.baseApiUrl}/categorias`).toPromise();
    if (Array.isArray(response?.data)) {
      response.data = [...response.data].sort((a, b) => a.nombreCategoria.localeCompare(b.nombreCategoria, 'es'));
    }
    return response;
    }

    async obtenerEstadisticas():Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApiUrl}/estadisticas`).toPromise();
    }

    async obtenerEmpresasPopulares():Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApiUrl}/empresas-populares`).toPromise();
    }

    async obtenerVacantes(tiempo: number, idModalidadEmpleo: number):Promise<any>{
        // URL en una sola línea: un salto de línea aquí se codifica como %0A y el API rechaza la petición
        return await this.httpClient.get<any>(`${this.baseApiUrl}/vacante-filtro/${tiempo}/${idModalidadEmpleo}`).toPromise();
    }

    async obtenerVacanteBuscador(buscador: Buscador, idEmpresa:number, rol:string):Promise<any>{
        let params = new HttpParams();
        if(buscador.palabra != null){
            params = params.set("palabra", buscador.palabra);
        }
        if(buscador.ubicacion != null){
            params = params.set("ubicacion", buscador.ubicacion);
        }
        return await this.httpClient.get<any>(
            `${this.baseApiUrl}/vacante-busqueda/${buscador.idCategoria}/${idEmpresa}/${rol}`,
            {params}
        ).toPromise();
    }

    async obtenerCandidatosDestacados():Promise<any>{
        return await this.httpClient.get<any>(`${this.baseApiUrl}/candidatos-destacados`).toPromise();
    }

}
